/**
 * Client Mod 容器初始化
 *
 * 加载 UI Registry、Client Runtime 以及业务 Mods，
 * 返回初始化后的 ModContainer 实例。
 *
 * SPA 和 SSR 入口共享此逻辑，避免重复代码。
 */

import { ModContainer } from 'hvsin'
import { uiRegistryMod } from '@hvsin/mod-ui-registry'
import { clientRuntimeMod } from '@hvsin/mod-client-runtime'
import { helloworldClientMod } from '@hvsin/mod-helloworld-client'
import { helloGreetingClientMod } from '@hvsin/mod-hello-greeting-client'
import { userClientMod } from '@hvsin/mod-user-client'
/**
 * 初始化客户端容器（async）
 *
 * 按照客户端 bundle 所需的依赖顺序加载 Mod：
 * 1. ui-registry（注册中心）
 * 2. helloworld-client（业务示例）
 * 3. hello-greeting-client（业务示例）
 * 4. client-runtime（运行时层）
 */
export async function initClientContainer(): Promise<ModContainer> {
  const container = new ModContainer()

  await container.loadMods([
    uiRegistryMod,          // 1. 注册中心
    helloworldClientMod,    // 2. Helloworld 示例
    helloGreetingClientMod, // 3. Greeting 示例
    userClientMod(),
    clientRuntimeMod,       // 4. 运行时层（初始化路由但不挂载 DOM）
  ])

  return container
}
